import React from 'react';
import { motion } from 'framer-motion';
import { Edit2, CheckCircle2 } from 'lucide-react';
interface ProfileSummaryProps {
  role: 'brand' | 'organizer';
  data: any;
  onEdit: () => void;
}
export function ProfileSummary({
  role,
  data,
  onEdit
}: ProfileSummaryProps) {
  const accentColor = role === 'brand' ? 'text-cyan-400' : 'text-purple-400';
  const bgGradient = role === 'brand' ? 'from-cyan-500/10 to-transparent' : 'from-purple-500/10 to-transparent';
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} className="bg-slate-800 border border-slate-700 rounded-2xl p-8 mb-12 relative overflow-hidden" data-id="element-599">
      <div className={`absolute top-0 right-0 w-64 h-64 bg-gradient-to-bl ${bgGradient} rounded-bl-full opacity-50 pointer-events-none`} data-id="element-600" />

      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 relative z-10" data-id="element-601">
        <div className="flex items-center gap-6" data-id="element-602">
          <div className="w-20 h-20 rounded-2xl bg-slate-700 flex items-center justify-center text-2xl font-bold text-slate-500" data-id="element-603">
            {data.logo ? <img src={data.logo} alt="Logo" className="w-full h-full object-cover rounded-2xl" data-id="element-604" /> : data.name?.[0] || 'L'}
          </div>
          <div data-id="element-605">
            <div className="flex items-center gap-3 mb-1" data-id="element-606">
              <h2 className="text-2xl font-bold text-white" data-id="element-607">
                {data.name || 'Your Name'}
              </h2>
              <span className="px-2 py-0.5 rounded-full bg-green-500/20 text-green-400 text-xs font-medium flex items-center gap-1" data-id="element-608">
                <CheckCircle2 size={12} data-id="element-609" /> Ready
              </span>
            </div>
            <p className="text-slate-400 text-lg mb-2" data-id="element-610">
              {data.tagline || 'Your catchy tagline goes here'}
            </p>
            <p className={`text-sm ${accentColor} font-medium`} data-id="element-611">
              {role === 'brand' ? 'Looking for partners' : 'Open for sponsorship'}
            </p>
          </div>
        </div>

        <button onClick={onEdit} className="px-4 py-2 rounded-full border border-slate-600 hover:border-slate-400 text-slate-300 hover:text-white text-sm font-medium transition-colors flex items-center gap-2" data-id="element-612">
          <Edit2 size={14} data-id="element-613" /> Edit Profile
        </button>
      </div>
    </motion.div>;
}